/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */

export type FeaturedAlbumsControllerListPlacement =
  (typeof FeaturedAlbumsControllerListPlacement)[keyof typeof FeaturedAlbumsControllerListPlacement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeaturedAlbumsControllerListPlacement = {
  HOMEPAGE: "HOMEPAGE",
  MARKETPLACE: "MARKETPLACE",
} as const;
